import { ORDER_PAYMENT_MAP } from '@utils/constants';

export const EDITABLE_PAYMENT_METHODS: (keyof typeof ORDER_PAYMENT_MAP)[] = ['efectivo', 'transferencia', 'tarjeta'];

/**
 * Verifica si un método de pago del backend puede ser editado
 * Compara tanto contra key como actualKey para manejar diferencias de capitalización
 * @param {string} paymentMethod - El método de pago recibido del backend
 * @param {string} orderStatus - El estatus actual del pedido
 * @param {boolean} hasEditModule - Si el usuario tiene el módulo de editar pedido
 * @returns {boolean} true si el método de pago es editable, false en caso contrario
 */
export const isPaymentMethodEditable = (
  paymentMethod: string,
  orderStatus: string,
  hasEditModule: boolean,
): boolean => {
  const isEditable = EDITABLE_PAYMENT_METHODS.some(
    (method) =>
      ORDER_PAYMENT_MAP[method].actualKey === paymentMethod || ORDER_PAYMENT_MAP[method].key === paymentMethod,
  );

  return isEditable && orderStatus !== 'delivered' && hasEditModule;
};

/**
 * Normaliza un método de pago del backend a su key interna
 * Si no encuentra match, retorna el valor original
 * @param {string} backendPaymentMethod - El método de pago recibido del backend
 * @returns {string} La key interna normalizada del método de pago
 */
export const normalizePaymentMethod = (backendPaymentMethod: string): string => {
  const entry = Object.entries(ORDER_PAYMENT_MAP).find(
    ([, value]) => value.actualKey === backendPaymentMethod || value.key === backendPaymentMethod,
  );

  return entry ? entry[0] : backendPaymentMethod;
};
